import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs";
import { useI18n } from "../../../i18n";
import { hours } from "../../../lib/xutil";
import { useApi } from "../../customer/hooks";
import { PageHead, Panel } from "../../../components/common/Page";
import { SkeletonBlock } from "../../../components/common/EmptyState";
import { ClockCard } from "./ClockCard";
import { DaysTable, WeekNav, useWeek } from "./Timesheet";
import { LeavePanel } from "./Leave";
import { DocsPanel } from "./Docs";
import { TeamPanel } from "./Team";
import { HrSettings } from "./Settings";

const MyWeek = () => {
  const { t } = useI18n();
  const [week, setWeek] = useWeek();
  const r = useApi("myTs", "/hr/timesheet", { week_start: week }, { staleTime: 0 });
  return (
    <Panel title={t("x.hr.tabs.timesheet")} sub={r.data ? `${t("x.hr.totalHours")}: ${hours(r.data.total_min)}` : null} action={<WeekNav week={week} setWeek={setWeek} />} testId="my-timesheet">
      {r.data ? <DaysTable days={r.data.days} editable={r.data.editable} onChange={r.refetch} testId="my-days" /> : <SkeletonBlock className="h-40" />}
    </Panel>
  );
};

export default function HrHome() {
  const { t } = useI18n();
  const [sp, setSp] = useSearchParams();
  const me = useApi("hrMe", "/hr/me", undefined, { staleTime: 0 });
  if (!me.data) return <SkeletonBlock className="h-64" />;
  const tabs = ["clock", "timesheet", "leave", "documents", ...(me.data.is_manager ? ["team"] : []), ...(me.data.can_settings ? ["settings"] : [])];
  const tab = tabs.includes(sp.get("tab")) ? sp.get("tab") : "clock";
  const setTab = (k) => setSp({ tab: k }, { replace: true });
  return (
    <div className="space-y-5" data-testid="hr-page">
      <PageHead title={t("x.hr.title")} />
      <Tabs value={tab} onValueChange={setTab}>
        <div className="-mx-4 overflow-x-auto px-4 pb-1">
          <TabsList className="h-12 w-max rounded-full bg-white p-1 shadow-sm">
            {tabs.map((k) => <TabsTrigger key={k} value={k} data-testid={`hr-tab-${k}`} className="h-10 rounded-full px-4 data-[state=active]:bg-navy data-[state=active]:text-white">{t(`x.hr.tabs.${k}`)}</TabsTrigger>)}
          </TabsList>
        </div>
        <TabsContent value="clock" className="mt-5 max-w-xl"><ClockCard me={me.data} onChange={me.refetch} /></TabsContent>
        <TabsContent value="timesheet" className="mt-5">{tab === "timesheet" && <MyWeek />}</TabsContent>
        <TabsContent value="leave" className="mt-5">{tab === "leave" && <LeavePanel me={me.data} onChange={me.refetch} />}</TabsContent>
        <TabsContent value="documents" className="mt-5">{tab === "documents" && <DocsPanel me={me.data} />}</TabsContent>
        <TabsContent value="team" className="mt-5">{tab === "team" && <TeamPanel />}</TabsContent>
        <TabsContent value="settings" className="mt-5">{tab === "settings" && <HrSettings />}</TabsContent>
      </Tabs>
    </div>
  );
}
